export function createVstStoreUrl(
  baseUrl: string,
  path = "/",
  params: Record<string, string> = {}
) {
  const storeUrlObj = new URL(baseUrl);
  // Allow append to e.g. https://www.vitalsource.com/mx/, with or without trailing slash
  storeUrlObj.pathname = `${storeUrlObj.pathname}${path}`.replace("//", "/");
  storeUrlObj.searchParams.set("utm_source", "bookshelfonline");
  storeUrlObj.searchParams.set("source", "bookshelf");
  Object.keys(params).forEach((param) => {
    storeUrlObj.searchParams.set(param, params[param]);
  });
  return storeUrlObj.toString();
}
